import React from 'react';

import { classNamesMerge } from '@/utils';

interface IDividerProps extends Omit<React.HTMLProps<HTMLDivElement>, 'width' | 'height'> {
    orientation?: 'horizontal' | 'vertical';
    bg?: `bg-${string}`;
    width?: `w-${string}`;
    height?: `h-${string}`;
}

const Divider: React.FC<IDividerProps> = ({ orientation = 'horizontal', bg = 'bg-white', width, height, className = '', ...restProps }) => {
    return <div className={classNamesMerge(classNamesMerge([bg, {
        'w-full h-[1px]': orientation === 'horizontal',
        'h-full w-[1px]': orientation === 'vertical',
    }], [width, height]), className)}  {...restProps} />;
};

export default Divider;
